@if (selectable()) {
  <td class="qr__cell qr__cell--select">
    <input type="checkbox" class="qr__case"
           [checked]="selected()"
           [attr.aria-label]="item().title | mathPlain"
           (change)="selectedChange.emit(!selected())" />
  </td>
}

<td class="qr__cell qr__cell--title">
  <span class="qr__title" [title]="item().title | mathPlain"><app-math-text [text]="item().title" [inline]="true"></app-math-text></span>
  @if (item().description) {
    <span class="qr__desc" [title]="item().description | mathPlain"><app-math-text [text]="item().description" [inline]="true"></app-math-text></span>
  }
</td>

<td class="qr__cell">
  <span class="qr__type">{{ typeKey() | translate }}</span>
</td>

<td class="qr__cell">
  <span class="qr__difficulty" [attr.data-level]="item().difficultyLevel">
    {{ difficultyKey() | translate }}
  </span>
</td>

<td class="qr__cell qr__cell--num">{{ item().points }}</td>

<td class="qr__cell">
  <span class="qr__pill qr__pill--status" [attr.data-status]="item().status">
    {{ statusKey() | translate }}
  </span>
</td>

<td class="qr__cell">
  <span class="qr__pill qr__pill--origin" [attr.data-origin]="item().origin">
    @if (isAiGenerated()) {
      <i class="fa-solid fa-robot" aria-hidden="true"></i>
    }
    {{ originKey() | translate }}
  </span>
</td>

<td class="qr__cell qr__cell--num">
  <span class="qr__version"
        [title]="'QUESTION_BANK.VERSION_LABEL' | translate:{ version: item().version }">
    v{{ item().version }}
  </span>
</td>

<td class="qr__cell qr__cell--theme">
  <span class="qr__theme" [title]="themeLabel()">{{ themeLabel() }}</span>
</td>

<td class="qr__cell qr__cell--date">
  @if (item().createdAt) {
    {{ item().createdAt | date: 'dd/MM/yyyy' }}
  } @else {
    <span class="qr__unknown">—</span>
  }
</td>

<td class="qr__cell qr__cell--actions">
  <div class="qr__actions">
    @if (canEdit()) {
      <button type="button" class="qr__action"
              [attr.aria-label]="'BUTTONS.EDIT' | translate"
              [title]="'BUTTONS.EDIT' | translate"
              (click)="edit.emit(item())">
        <i class="fa-solid fa-pen" aria-hidden="true"></i>
      </button>
    }
    @if (canDelete()) {
      <button type="button" class="qr__action qr__action--danger"
              [attr.aria-label]="'BUTTONS.DELETE' | translate"
              [title]="'BUTTONS.DELETE' | translate"
              (click)="remove.emit(item())">
        <i class="fa-solid fa-trash" aria-hidden="true"></i>
      </button>
    }
    @if (!canEdit() && !canDelete()) {
      <span class="qr__locked" [title]="'QUESTION_BANK.ARCHIVED_LOCKED' | translate">
        <i class="fa-solid fa-lock" aria-hidden="true"></i>
      </span>
    }
  </div>
</td>
